
export const calculateProcessingTime = (audioDuration: number) => {
  return audioDuration * 0.5; // Estimated processing time is 50% of audio duration
};

export const sanitizeFileName = (fileName: string): string => {
  return fileName
    .replace(/[^a-zA-Z0-9.-]/g, '_')
    .replace(/_{2,}/g, '_')
    .toLowerCase();
};
